import { Stack, SxProps, Theme } from '@mui/material';
import { ArrowDown, ArrowUp } from 'lucide-react';
import ExpandCollapseAction from './components/ExpandCollapseAction';
import { ExpandCollapseActionConfig } from './expandCollapseButtonGroup.types';

interface ExpandCollapseButtonGroupProps {
  collapse: ExpandCollapseActionConfig;
  expand: ExpandCollapseActionConfig;
  fullWidth?: boolean;
}

const collapseSx: SxProps<Theme> = { borderTopRightRadius: 0, borderBottomRightRadius: 0 };

const expandSx: SxProps<Theme> = {
  borderTopLeftRadius: 0,
  borderBottomLeftRadius: 0,
  borderLeft: 'none',
};

const ExpandCollapseButtonGroup = ({
  collapse,
  expand,
  fullWidth = false,
}: ExpandCollapseButtonGroupProps) => (
  <Stack direction="row" sx={{ alignItems: 'center', width: fullWidth ? '100%' : 'auto' }}>
    <ExpandCollapseAction
      label={collapse.label}
      testId={collapse.testId}
      icon={ArrowUp}
      fullWidth={fullWidth}
      sx={collapseSx}
      onClick={collapse.onClick}
    />
    <ExpandCollapseAction
      label={expand.label}
      testId={expand.testId}
      icon={ArrowDown}
      fullWidth={fullWidth}
      sx={expandSx}
      onClick={expand.onClick}
    />
  </Stack>
);

export default ExpandCollapseButtonGroup;
